module.exports = {"420304101":"安阳镇","420304102":"杨溪铺镇","420304103":"青曲镇","420304104":"白桑关镇","420304105":"南化塘镇","420304106":"白浪镇","420304107":"刘洞镇","420304108":"谭山镇","420304109":"梅铺镇","420304110":"青山镇","420304111":"茶店镇","420304112":"柳陂镇","420304113":"鲍峡镇","420304114":"胡家营镇","420304115":"谭家湾镇","420304117":"城关镇","420304200":"大柳乡","420304201":"五峰乡","420304202":"叶大乡","420304400":"沧浪山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420304.json
// module id = 1842
// module chunks = 0